import api from '../api';

export const authService = {
  login,
  logout,
  getProfile,
  getCurrentUser,
  getToken,
  isAuthenticated,
};

/**
 * Login via IHC Portal API
 * POST /auth/login
 * Body: { email, password }
 * Response: { status, message, data: { user, token } }
 */
async function login(email, password) {
  const response = await api.post('/auth/login', { email, password });
  const result = response.data;

  // Handle various response structures from the API
  // Expecting: { status: "success", data: { user: {...}, token: "..." } }
  // Or: { status: "success", authorization: { token: "..." }, user: {...} }
  let token = null;
  let user = null;

  if (result.data && result.data.token) {
    token = result.data.token;
    user = result.data.user || result.data;
  } else if (result.authorization && result.authorization.token) {
    token = result.authorization.token;
    user = result.user || result.data;
  } else if (result.token) {
    token = result.token;
    user = result.user || result.data;
  } else if (result.access_token) {
    token = result.access_token;
    user = result.user || result.data;
  }

  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    sessionStorage.setItem('authUser', JSON.stringify(user));
  }

  return { token, user, raw: result };
}

/**
 * Logout via IHC Portal API
 * POST /auth/logout
 */
async function logout() {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      await api.post('/auth/logout');
    }
  } catch (error) {
    // Even if API call fails, still clear local storage
    console.warn('Logout API call failed:', error.message);
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('authUser');
  }
}

/**
 * Get user profile from API
 * GET /auth/profile or /auth/me
 */
async function getProfile() {
  try {
    const response = await api.get('/auth/me');
    return response.data;
  } catch (error) {
    // Try alternate endpoint
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await api.get('/auth/profile');
      return response.data;
    } catch (err) {
      throw err;
    }
  }
}

/**
 * Get current user from localStorage
 */
function getCurrentUser() {
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
}

/**
 * Get stored token
 */
function getToken() {
  return localStorage.getItem('token');
}

/**
 * Check if user is authenticated
 */
function isAuthenticated() {
  return !!getToken();
}

export default authService;
